module.exports = __webpack_public_path__ + "img/Modernisme_Radioen1.7b2de6f6.jpg";